import { $, $$, fetchCasinos, debounce, fetchGames } from './utils'

;(() => {
  const finders = $$('.spinoko-finder')
  if (!finders.length) return

  const SpinokoFinder = async (type, texts, elements) => {
    const { resultsWrapper, clearButton, searchInput } = elements

    const handleKeyUpEvent = async (e) => {
      resultsWrapper.innerText = ''
      resultsWrapper.classList.add('loading')
      clearButton.classList.add('hidden')

      const value = searchInput.value.toLowerCase()
      if (!value) {
        resultsWrapper.classList.remove('loading')
        return
      }

      // get the first 100 items from WP JSON API
      const apiData = await getItems(type)
      const items = apiData.items.filter((item) => checkItemName(item, type, value))

      // if there are more than 100 items, get the rest of them
      if (apiData.totalPages > 1) {
        for (let i = 2; i <= apiData.totalPages; i++) {
          const rest = await getItems(type, i)
          rest.items.forEach((item) => {
            const f = checkItemName(item, type, value)
            if (f) items.push(f)
          })
        }
      }

      if (items.length) {
        resultsWrapper.innerText = ''
        resultsWrapper.classList.remove('loading')
        items.map((item) => finderItem(type, item, texts)).forEach((item) => resultsWrapper.appendChild(item))
      } else {
        resultsWrapper.innerText = ''
        resultsWrapper.classList.remove('loading')
        resultsWrapper.appendChild(notFound(texts.notFound))
      }

      clearButton.classList.remove('hidden')
    }

    const debouncedKeyUpHandler = debounce(() => handleKeyUpEvent(), 400)

    searchInput.addEventListener('input', debouncedKeyUpHandler)

    searchInput.addEventListener('keyup', (e) => e.code === 'Escape' && resetFinder(elements))

    clearButton.addEventListener('click', () => resetFinder(elements))
  }

  finders.forEach((finder) => {
    const searchInput = $('.spinoko-finder--input', finder)
    const resultsWrapper = $('.finder-results', finder)
    const clearButton = $('.spinoko-finder--clear', finder)
    if (!searchInput || !resultsWrapper || !clearButton) return

    if (finder.classList.contains('spinoko-finder__games')) {
      SpinokoFinder(
        'game',
        {
          reviewAnchor: finder.dataset.reviewLink,
          notFound: finder.dataset.notFound,
        },
        {
          searchInput,
          clearButton,
          resultsWrapper,
        },
      )
    } else {
      SpinokoFinder(
        'casino',
        {
          affAnchor: finder.dataset.affiliateLink,
          reviewAnchor: finder.dataset.reviewLink,
          notFound: finder.dataset.notFound,
        },
        {
          searchInput,
          clearButton,
          resultsWrapper,
        },
      )
    }
  })

  const getItems = async (type, page = 1) => {
    return type === 'game' ? await fetchGames(page) : await fetchCasinos(page)
  }

  const checkItemName = (item, type, value) => {
    const customFieldsItem = type === 'game' ? 'game_fields' : 'casino_fields'
    return item[customFieldsItem]?.name?.toLowerCase()?.includes(value) ? item : null
  }

  const finderItem = (type, item, texts) => {
    return type === 'game' ? gameItem(item, texts) : casinoItem(item, texts)
  }

  const casinoItem = (casino, texts) => {
    const name = casino.casino_fields.name

    const blocks = [
      _itemLogo(casino.casino_fields.logo.url, name, casino.casino_fields.affiliate_link),
      _itemTextsBlock(name, casino.casino_fields.bonus_main || casino.casino_fields.bonus_short),
      _itemLinksBlock(
        _itemButton(casino.casino_fields.affiliate_link, texts.affAnchor),
        _itemLink(casino.link, texts.reviewAnchor),
      ),
    ]

    return _itemWrapper(blocks)
  }

  const gameItem = (game, texts) => {
    const name = game.game_fields.name

    return _itemWrapper([
      _itemLogo(game.game_fields.image, name, game.link),
      _itemTextsBlock(name, game.game_fields.game_providers.label),
      _itemLinksBlock(_itemButton(game.link, texts.reviewAnchor)),
    ])
  }

  const _itemWrapper = (blocks) => {
    const div = document.createElement('div')
    div.classList.add(
      'spinoko-finder--item',
      'spinoko_rounded',
      'flex',
      'flex-wrap',
      'items-center',
      'sp-p-4',
      'bg-white',
      'text-center',
      'md:text-left',
      'spinoko_shadow',
    )
    blocks.forEach((block) => div.appendChild(block))

    return div
  }

  const _itemLogo = (src, name, url) => {
    const logoLink = document.createElement('a')
    logoLink.href = url
    logoLink.classList.add('w-full', 'md:w-auto', 'sp-mb-2', 'md:sp-mb-0', 'md:sp-mr-6')

    const logo = document.createElement('img')
    logo.src = src
    logo.setAttribute('alt', name)
    logo.classList.add('block', 'h-[68px]', 'sp-mx-auto', 'spinoko_rounded')

    logoLink.appendChild(logo)

    return logoLink
  }

  const _itemTextsBlock = (spanOneText, spanTwoText) => {
    const textBlock = document.createElement('span')
    textBlock.classList.add('grow', 'sp-mb-2', 'md:sp-mb-0', 'md:sp-mr-6')

    const spanOne = document.createElement('span')
    spanOne.classList.add('font-bold', 'text-lg', 'md:text-2xl')
    spanOne.innerText = spanOneText

    const spanTwo = document.createElement('span')
    spanTwo.classList.add('block', 'text-lg', 'font-bold', 'text-neutral', 'uppercase')
    spanTwo.innerText = spanTwoText

    textBlock.appendChild(spanOne)
    textBlock.appendChild(spanTwo)

    return textBlock
  }

  const _itemLinksBlock = (linkOne, linkTwo = null) => {
    const linksWrapper = document.createElement('div')
    linksWrapper.classList.add('w-full', 'max-w-[220px]', 'sp-mx-auto')
    linksWrapper.appendChild(linkOne)
    linkTwo && linksWrapper.appendChild(linkTwo)

    return linksWrapper
  }

  const _itemButton = (href, anchor, id = null) => {
    const a = document.createElement('a')
    a.href = href
    a.setAttribute('rel', 'nofollow noopener noreferrer')
    a.setAttribute('target', '_blank')
    a.classList.add('button-casino', 'button-casino__outline', 'w-full', 'spinoko_rounded')
    a.innerText = anchor

    return a
  }

  const _itemLink = (href, anchor) => {
    if (anchor === 'none') {
      return null
    }

    const a = document.createElement('a')
    a.href = href
    a.classList.add('flex-center', 'sp-mt-1', 'text-sm', 'text-dark', 'font-bold', 'uppercase', 'no-underline')
    a.innerText = anchor

    return a
  }

  const notFound = (anchor) => {
    const span = document.createElement('span')
    span.classList.add('spinoko-finder--item-404', 'block', 'sp-p-4', 'border', 'border-error', 'rounded')
    span.innerText = anchor
    return span
  }

  const resetFinder = (elements) => {
    elements.resultsWrapper.innerText = ''
    elements.clearButton.classList.add('hidden')
    elements.searchInput.value = ''
    elements.searchInput.focus()
  }
})()
